export default "__VITE_ASSET__CPfs5uBD__ 1920w";